// extracted by mini-css-extract-plugin
module.exports = {"countParent":"PaginatedTable_countParent__2XCHn","count":"PaginatedTable_count__VK1Q3","clearButton":"PaginatedTable_clearButton__1xx13"};